import React from "react";
import { AlertTriangle, Check, Copy, X } from "lucide-react";
import { formatScore, scoreBand } from "../lib/utils";
import { useLocale } from "../lib/i18n";

export const Badge = ({ children, tone = "neutral", className = "" }) => (
  <span className={`badge badge-${tone} ${className}`.trim()}>{children}</span>
);

export const ScorePill = ({ value, label, compact = false }) => (
  <div className={`score-pill score-${scoreBand(value)} ${compact ? "score-compact" : ""}`}>
    {label ? <span>{label}</span> : null}
    <strong>{formatScore(value)}</strong>
  </div>
);

export const StatusMark = ({ passed, label }) => (
  <span className={`status-mark ${passed ? "status-pass" : "status-fail"}`}>
    {passed ? <Check size={13} /> : <X size={13} />}
    {label}
  </span>
);

export const Empty = ({ title, body }) => (
  <div className="empty-state">
    <div className="empty-orbit" />
    <h3>{title}</h3>
    <p>{body}</p>
  </div>
);

export const SectionHeader = ({ eyebrow, title, aside }) => (
  <div className="section-header">
    <div>
      {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
      <h2>{title}</h2>
    </div>
    {aside ? <div className="section-aside">{aside}</div> : null}
  </div>
);

export const CopyButton = ({ value, label }) => {
  const { t } = useLocale();
  const [copied, setCopied] = React.useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(value || "");
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1200);
  };
  return (
    <button type="button" className="icon-button" onClick={copy} title={label || t("copy.copy")} aria-label={label || t("copy.copy")}>
      {copied ? <Check size={15} /> : <Copy size={15} />}
    </button>
  );
};

export const IssueIcon = ({ severity }) =>
  severity === "error" ? <X size={14} /> : <AlertTriangle size={14} />;
